import { FC } from 'react';
import { NavDropdown } from 'react-bootstrap';
import styles from './MenuDropDownItem.module.css';
import cn from 'classnames';

interface MenuDropDownItemProps {
  title: string;
  to: string;
}

const MenuDropDownItem: FC<MenuDropDownItemProps> = ({ title, to }) => {
  return (
    <NavDropdown.Item className={cn(styles.item)} eventKey={to}>
      {title}
    </NavDropdown.Item>
  );
};

export default MenuDropDownItem;
